export default __webpack_public_path__ + "static/media/glitter.44e2ddac.svg";